import { Observable } from 'rxjs';

export abstract class IframeModuleService {
    abstract getConfiguration(): Observable<any>;
}
